import http from "./HttpService";
import { FAQS_STORE_NAME } from "../constants";
import { getLookupEntries, saveLookupEntriesWithMeta } from "./db";

export const API_ENDPOINT = `system/user-guides/public`;
export const API_ENDPOINT_VIDEO = `system/video-guides/public`;
export const API_ENDPOINT_FAQS = `system/faqs/public-module`;
const EVENTS_MODULE = "events";

export const getUserGuides = async (moduleName= EVENTS_MODULE) => {
    const response = http.get(`${API_ENDPOINT}/${moduleName}`);
    return response;
  }

export const uploadDocument = async (document, moduleName= EVENTS_MODULE) => {
  const multiPartHeaders = {
    "Content-Type": "multipart/form-data",
  };

   const response = await http.post(`${API_ENDPOINT}/${moduleName}`, document, {
     headers: multiPartHeaders,
   });
  return  response;
};

export const getVideoUserGuides = async (moduleName= EVENTS_MODULE) => {
  const { data } = await http.get(`${API_ENDPOINT_VIDEO}/${moduleName}`);
  return data;
};

export const downloadFile = async (id) => {
   const response = await http.get(`${API_ENDPOINT}/download/${id}`, {
     responseType: "arraybuffer",
   });
  //  { responseType: 'arraybuffer', ...axiosConfigs })
   return  response;
};

/* =====================================================
   GET FAQs (Offline-First with Robust Fallback)
   ===================================================== */

export const getFaqs = async () => {
  let networkError = null;

  // Try network FIRST (if online)
  if (navigator.onLine) {
    try {
      const res = await http.get(`${API_ENDPOINT_FAQS}/${EVENTS_MODULE}`);

      if (res?.status === 200) {
        const raw = res.data?.faqs || res.data || [];
        const faqs = raw.filter(f => !f.confidential);

        // Update cache (non-blocking, safe)
        if (faqs.length > 0) {
          saveLookupEntriesWithMeta(FAQS_STORE_NAME, faqs, Date.now().toString());
        }

        return {
          status: 200,
          data: faqs,
          source: "network",
        };
      }

      // treat non-200 as failure → fallback
      networkError = new Error("Non-200 response");
    } catch (err) {
      console.warn("Network request for FAQs failed, falling back to cache", err);
      networkError = err;
    }
  }

  // Fallback to cache (ALWAYS attempted)
  try {
    const cachedFaqs = await getLookupEntries(FAQS_STORE_NAME);

    return {
      status: 200,
      data: cachedFaqs || [],
      source: "cache",
      fallbackFrom: navigator.onLine ? "network-error" : "offline",
    };
  } catch (cacheErr) {
    console.error("Failed to read FAQs from cache", cacheErr);

    return {
      status: 500,
      data: [],
      source: "error",
      error: networkError || cacheErr,
    };
  }
};
